/**
 * @flow
 * @relayHash 51f2da6f2e147352ec70d71971acfb5f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SetUserCauseInput = {|
  userId: string,
  causeId: string,
  clientMutationId?: ?string,
|};
export type SetUserCauseMutationVariables = {|
  input: SetUserCauseInput
|};
export type SetUserCauseMutationResponse = {|
  +setUserCause: ?{|
    +user: ?{|
      +id: string,
      +cause: ?{|
        +id: string
      |},
    |}
  |}
|};
export type SetUserCauseMutation = {|
  variables: SetUserCauseMutationVariables,
  response: SetUserCauseMutationResponse,
|};
*/


/*
mutation SetUserCauseMutation(
  $input: SetUserCauseInput!
) {
  setUserCause(input: $input) {
    user {
      id
      cause {
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SetUserCauseInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "setUserCause",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SetUserCausePayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "cause",
            "storageKey": null,
            "args": null,
            "concreteType": "Cause",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SetUserCauseMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "SetUserCauseMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "SetUserCauseMutation",
    "id": null,
    "text": "mutation SetUserCauseMutation(\n  $input: SetUserCauseInput!\n) {\n  setUserCause(input: $input) {\n    user {\n      id\n      cause {\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0d919674ad073438cfe680e8113bad4d';
module.exports = node;
